package com.example.readingnotes.domain.usecase

import com.example.readingnotes.domain.model.*
import com.example.readingnotes.domain.repository.PaidContentRepository
import com.example.readingnotes.util.Result

/**
 * Set price for a post (make it purchasable)
 */
class SetPostPriceUseCase(
    private val repository: PaidContentRepository,
) {
    suspend operator fun invoke(
        tenantSlug: String,
        postId: String,
        price: Int,
        currency: String,
    ): Result<PurchasableContent> =
        repository.setPostPrice(tenantSlug, postId, price, currency)
}

/**
 * Create checkout session for purchasing content
 */
class CreatePurchaseSessionUseCase(
    private val repository: PaidContentRepository,
) {
    suspend operator fun invoke(
        contentId: String,
        successUrl: String,
        cancelUrl: String,
    ): Result<PurchaseSession> =
        repository.createPurchaseSession(contentId, successUrl, cancelUrl)
}

/**
 * Check purchase/access status for content
 */
class GetContentAccessUseCase(
    private val repository: PaidContentRepository,
) {
    suspend operator fun invoke(contentId: String): Result<ContentAccessResult> =
        repository.getContentAccess(contentId)
}

/**
 * Get user's purchases
 */
class GetUserPurchasesUseCase(
    private val repository: PaidContentRepository,
) {
    suspend operator fun invoke(): Result<List<ContentPurchase>> = repository.getUserPurchases()
}

/**
 * Get sales dashboard for creator
 */
class GetSalesDashboardUseCase(
    private val repository: PaidContentRepository,
) {
    suspend operator fun invoke(tenantSlug: String): Result<SalesDashboard> =
        repository.getSalesDashboard(tenantSlug)
}

/**
 * Refund a purchase
 */
class RefundPurchaseUseCase(
    private val repository: PaidContentRepository,
) {
    suspend operator fun invoke(purchaseId: String): Result<ContentPurchase> =
        repository.refundPurchase(purchaseId)
}
